export interface CustomerRateActionTypes {
  type: CustomerRateActions;
  payload?: any;
}

export enum CustomerRateActions {
  CREATE_CUSTOMER_RATE = "CREATE_CUSTOMER_RATE",
  GET_CUSTOMER_RATE_LIST = "GET_CUSTOMER_RATE_LIST",
  SET_CUSTOMER_RATE_LIST = "SET_CUSTOMER_RATE_LIST",
  SET_CUSTOMER_RATE_LIST_PAGE_COUNT = "SET_CUSTOMER_RATE_LIST_PAGE_COUNT",
  GET_CUSTOMER_RATE_DATA_BY_ID = "GET_CUSTOMER_RATE_DATA_BY_ID",
  SET_CUSTOMER_RATE_DATA_BY_ID = "SET_CUSTOMER_RATE_DATA_BY_ID",
  EDIT_CUSTOMER_RATE_DATA_BY_ID = "EDIT_CUSTOMER_RATE_DATA_BY_ID",
}
